import { getChartLabelIdOrName } from '@modules/charts/utils';
import { SourceDetail } from 'v2/core/entities/feedback/sources';
import { FieldNames, SourceName } from 'v2/core/entities/fields';
import { decodeSourceFromString } from 'v2/core/services/queryBuilder/utils';

export const getCountForFieldEQLFunctionParams = (
  dataPoints: string[] = [],
  eqlField?: FieldNames,
  sourceDetailsMap?: Map<SourceName, SourceDetail>,
): string[] => {
  if (eqlField === FieldNames.Source) {
    const parsedSources = dataPoints.map((source) => {
      const parsedSourceObject = decodeSourceFromString(source);
      const namespace = parsedSourceObject.namespace;
      const sourceName = parsedSourceObject.name;
      const sourceString =
        sourceDetailsMap?.get(sourceName)?.eqlValue ?? sourceName;

      return namespace ? `${sourceString}-${namespace}` : sourceString;
    });

    return parsedSources;
  }

  if (eqlField === FieldNames.Entity) {
    return dataPoints;
  }

  return dataPoints.map((point) => getChartLabelIdOrName(point));
};
